import { ReduxService } from 'dashboard-services/services';

import { executeModalDataScienceActions } from 'actions/modules/datascience';

export const executeModalInitial = {
  id: undefined,
  name: undefined,
  open: false,
  triggers: []
}

export default (state = executeModalInitial, action) => {
  switch (action.type) {
    case executeModalDataScienceActions.CHANGE_VALUE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    default:
      return state;
  }
}